export default "__VITE_ASSET__X_xK6TXL__"